import React, { useEffect, useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
  CarouselLabel,
} from "../../layouts/content/readingCarousel";
import { EmblaOptionsType } from "embla-carousel";
import { ChevronLeft, ChevronRight, LucideIcon } from "lucide-react";

interface Props {
  items: React.ReactNode[];
  itemClassName?: string;
  options?: EmblaOptionsType;
  plugins?: any;
  orientation?: "vertical" | "horizontal";
  prevIcon?: LucideIcon;
  nextIcon?: LucideIcon;
  labelClassName?: string;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
}

export const ReadingCarousel = ({
  items,
  options,
  plugins,
  orientation = "horizontal",
  itemClassName = "md:basis-1/3 lg:basis-1/5",
  prevIcon = ChevronLeft,
  nextIcon = ChevronRight,
  labelClassName,
  onNextClick,
  onPreviousClick,
}: Props) => {
  return (
    <Carousel
      className="h-full w-full"
      opts={options}
      plugins={plugins}
      orientation={orientation}
    >
      <CarouselContent className="h-full w-full">
        {items?.map((item, index) => (
          <CarouselItem key={index} className={itemClassName}>
            {item}
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className={labelClassName}>
        <CarouselPrevious
          dir={options?.direction}
          Icon={prevIcon}
          onClick={onPreviousClick}
        />
        <CarouselLabel />
        <CarouselNext
          dir={options?.direction}
          Icon={nextIcon}
          onClick={onNextClick}
        />
      </div>
    </Carousel>
  );
};
